// Minimal JSX runtime: h() + Fragment, the two things our compiled
// TSX templates need to construct the virtual element tree that
// render.ts walks to produce ANSI.
//
// The tree shape is intentionally tiny — every node is either a string,
// a number, or an object with { __k: true, tag, props, children }. The
// renderer pattern-matches on `tag` to decide what SGR/control codes to
// emit. There is no diffing, no reconciliation, no hooks — components
// are just functions that return trees.
/** Type guard for {@link JSXElement} values. */
export function isJSXElement(v) {
    return (typeof v === 'object' &&
        v !== null &&
        !Array.isArray(v) &&
        v.__k === true);
}
export function Fragment(props = {}) {
    return { __k: true, tag: Fragment, props, children: props.children ?? [] };
}
export function h(tag, props, ...kids) {
    const flat = [];
    const stack = [...kids];
    while (stack.length) {
        const x = stack.shift();
        if (x == null || x === false || x === true)
            continue;
        if (Array.isArray(x)) {
            stack.unshift(...x);
            continue;
        }
        flat.push(x);
    }
    return { __k: true, tag, props: props ?? {}, children: flat };
}
//# sourceMappingURL=jsx-runtime.js.map